import { fetcher } from "helpers/fetcher";

import {
  TAddStaffRetirementPaymentReq,
  TAddStaffRetirementPaymentRes,
} from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const addEmployeeRetirementPayment = async (
  payload: TAddStaffRetirementPaymentReq
) => {
  return await fetcher<
    TAddStaffRetirementPaymentRes,
    TAddStaffRetirementPaymentReq["data"]
  >(ENDPOINT.USER.ADD_EMPLOYEE_RETIREMENT_PAYMENT, {
    data: payload.data,
    headers: {
      [API_HEADER.USER_ID]: payload.idUser,
      [API_HEADER.VERSION]:
        ENDPOINT.USER.ADD_EMPLOYEE_RETIREMENT_PAYMENT.version,
    },
  });
};

export const mutationAddEmployeeRetirementPayment = async (
  payload: TAddStaffRetirementPaymentReq
) => {
  return (await addEmployeeRetirementPayment(payload)).data.message;
};

mutationAddEmployeeRetirementPayment._key = (
  payload: TAddStaffRetirementPaymentReq
) => [ENDPOINT.USER.ADD_EMPLOYEE_RETIREMENT_PAYMENT.url, payload];
